import { SOURCE_CONTEXT_NAMES, WIDGET_LOGICAL_NAMES } from '@config/Consts';
import BaseService from '@core/common/BaseService';
import { EVENTS, MsgHistoryClient, RESOURCES } from '@core/clients/MsgHistoryClient';
import { Subscription } from '@core/common/Subscription';
import conversationsTransformer from './conversationsTransformer';

let cancellationToken = null;

function createConversationsClients(params) {
  const searchEngagementClient = new MsgHistoryClient({
    resource: RESOURCES.SEARCH_ENGAGEMENTS,
    contextName: SOURCE_CONTEXT_NAMES[WIDGET_LOGICAL_NAMES.CONVERSATIONS],
  });
  searchEngagementClient.useRequestInterceptor(params.interceptor);
  return {
    searchEngagementClient,
  };
}

function stopListenToConversationsClientEvents() {
  const searchEngagementsClient = this.conversationsClients.searchEngagementClient;
  searchEngagementsClient.clearAllListeners(EVENTS.onPollingSuccess);
  searchEngagementsClient.clearAllListeners(EVENTS.onPollingError);
}

async function enrichConversationsData(settings, searchEngagementsResponse) {
  const conversationsResponse = conversationsTransformer.transformConversationsResponse(settings, {
    searchEngagementsResponse,
  });
  const onSubscriptionUpdateEvent = Subscription.EVENTS.onSubscriptionUpdateNotification;
  this.subscription.emit(onSubscriptionUpdateEvent, conversationsResponse);
}

function onConversationsSubscriptionError(error) {
  this.subscription.emit(Subscription.EVENTS.onSubscriptionError, error);
}

function listenToConversationsClientEvents(settings) {
  const searchEngagementClient = this.conversationsClients.searchEngagementClient;
  stopListenToConversationsClientEvents.call(this);
  searchEngagementClient.on(
    EVENTS.onPollingSuccess,
    enrichConversationsData.bind(this, settings),
    'ConversationServicePollingSuccess');
  searchEngagementClient.on(
    EVENTS.onPollingError, onConversationsSubscriptionError.bind(this),
    'ConversationServicePollingError');
}

function conversationsSubscriptionStartMethod(settings) {
  const conversationsRequest = conversationsTransformer.transformConversationsRequest(settings);

  listenToConversationsClientEvents.call(this, settings);
  cancellationToken =
    this.conversationsClients.searchEngagementClient.subscribe(conversationsRequest);
}

function conversationsSubscriptionStopMethod() {
  if (cancellationToken) {
    stopListenToConversationsClientEvents.call(this);
    this.conversationsClients.searchEngagementClient.unsubscribe(cancellationToken);
  }
}

/**
 * Conversations service - retrieves the operational data for Conversations List widget
 * Requests data from one api:
 * Messaging Interactions
 */
class ConversationsService extends BaseService {
  constructor() {
    super({ name: 'ConversationsService' });
  }

  getSubscription(params) {
    if (!this.subscription) {
      this.conversationsClients = createConversationsClients(params);
      this.subscription = new Subscription({
        name: 'ConversationsSubscription',
        resourceName: RESOURCES.SEARCH_ENGAGEMENTS,
        handlers: {
          start: conversationsSubscriptionStartMethod.bind(this),
          stop: conversationsSubscriptionStopMethod.bind(this),
        },
      });
    }

    return this.subscription;
  }
}

const conversationsService = new ConversationsService();

export default conversationsService;
